import {
  CustomerSigner,
  DocumentSignatureStatus,
  DocumentType,
} from '@bulthaup/api/db';
import { Button, Group, Stack } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconEye, IconTrash } from '@tabler/icons-react';

import { SignatureRequestButton } from '../../../-components/-signature-request-button';
import { SignatureRequestStatusBadge } from '../../../-components/-signature-request-status-badge';
import { CancelSignatureRequestButton } from '../../../-components/cancel-signature-request-button';
import { ConstructionSiteReviewButton } from '../../../-components/construction-site-review/construction-site-review-button';
import { ConstructionSiteReviewList } from '../../../-components/construction-site-review/construction-site-review-list';
import { RouterOutput, trpc } from '../../../../../../../services/trpc';
import { getUTDocumentUrl } from '../../../../../../../services/upload';

export function ConstructionSiteReviewSection({
  project,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
}) {
  const deleteUnsignedDocument =
    trpc.documents.deleteUnsignedDocument.useMutation();

  const CSReviewDocuments = project.documents.filter(
    document => document.type === DocumentType.CONSTRUCTION_SITE_REVIEW,
  );
  const lastCSRDocument =
    CSReviewDocuments.length > 0
      ? CSReviewDocuments.slice().sort(
          (a, b) => a.createdAt.getTime() - b.createdAt.getTime(),
        )[CSReviewDocuments.length - 1]
      : undefined;

  const signatureRecipient = {
    [CustomerSigner.CLIENT1]: `${project.customer.customer1Title} ${project.customer.customer1FirstName} ${project.customer.customer1LastName} - ${project.customer.customer1Email}`,
    [CustomerSigner.CLIENT2]: `${project.customer.customer2Title} ${project.customer.customer2FirstName} ${project.customer.customer2LastName} - ${project.customer.customer2Email}`,
  }[project.customer.signer as CustomerSigner];

  if (
    !lastCSRDocument ||
    !(
      [
        DocumentSignatureStatus.ONGOING,
        DocumentSignatureStatus.DRAFT,
      ] as DocumentSignatureStatus[]
    ).includes(lastCSRDocument.signatureStatus)
  ) {
    return (
      <Stack>
        <Group>
          <ConstructionSiteReviewButton
            project={project}
            label={'Ajouter un compte-rendu'}
          />
        </Group>
        <ConstructionSiteReviewList CSReviewDocuments={CSReviewDocuments} />
      </Stack>
    );
  }

  if (lastCSRDocument.signatureStatus === DocumentSignatureStatus.DRAFT) {
    return (
      <Stack>
        <Group>
          {/* <ConstructionSiteReviewButton
            project={project}
            label={"Refaire le compte-rendu"}
            initialValues={{
              ...lastCSRDocument.CSReviewMeta!,
              date: lastCSRDocument.CSReviewMeta?.date
                ? new Date(
                    lastCSRDocument.CSReviewMeta.date as unknown as string
                  )
                : undefined,
            }}
          /> */}
          <Button
            leftSection={<IconEye size={16} />}
            variant="outline"
            onClick={() => {
              window.open(
                getUTDocumentUrl(lastCSRDocument.utFileKey),
                '_blank',
              );
            }}
          >
            Voir le document
          </Button>
          {lastCSRDocument.signatureStatus ===
            DocumentSignatureStatus.DRAFT && (
            <Button
              variant="outline"
              leftSection={<IconTrash size={16} />}
              onClick={async () => {
                if (
                  confirm(
                    'Voulez-vous vraiment supprimer le compte-rendu de chantier ?\n\nCette action est irréversible.',
                  )
                ) {
                  await deleteUnsignedDocument.mutateAsync({
                    projectId: project.id,
                    documentType: DocumentType.CONSTRUCTION_SITE_REVIEW,
                  });
                  notifications.show({
                    title: 'Compte-rendu de chantier supprimé',
                    message: '',
                    color: 'green',
                  });
                }
              }}
            >
              Supprimer
            </Button>
          )}
        </Group>
        <Group>
          <SignatureRequestButton
            documentId={lastCSRDocument.id}
            recipient={signatureRecipient}
            label="Envoyer compte-rendu pour signature"
            signatureRequestName={`Compte-rendu de chantier ${project.name}`}
          />
        </Group>
        <ConstructionSiteReviewList CSReviewDocuments={CSReviewDocuments} />
      </Stack>
    );
  }

  if (lastCSRDocument.signatureStatus === DocumentSignatureStatus.ONGOING) {
    return (
      <Stack>
        <Group>
          <CancelSignatureRequestButton
            documentId={lastCSRDocument.id}
            label="Annuler la signature"
          />
          <Button
            leftSection={<IconEye size={16} />}
            variant="outline"
            onClick={() => {
              window.open(
                getUTDocumentUrl(lastCSRDocument.utFileKey),
                '_blank',
              );
            }}
          >
            Voir le document
          </Button>
        </Group>
        <Group>
          <SignatureRequestStatusBadge
            status={lastCSRDocument.signatureStatus}
          />
        </Group>
        <ConstructionSiteReviewList CSReviewDocuments={CSReviewDocuments} />
      </Stack>
    );
  }
}
